module.exports = __webpack_public_path__ + "img/the_behavior_bussiness.323ac64c.jpg";